import MenuEditorAdvanced from '../MenuEditorAdvanced';

const PageMenuAdvanced = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
	console.log("page menu advanced")
	return (
		<div id="ms-profile">

	        <div className="ms-section">
	        	<MenuEditorAdvanced />
            </div>

	        </div>
	)

}

export default PageMenuAdvanced;